/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LeadAssignmentRole } from './LeadAssignmentRole';
import {
    LeadAssignmentRoleFromJSON,
    LeadAssignmentRoleFromJSONTyped,
    LeadAssignmentRoleToJSON,
} from './LeadAssignmentRole';

/**
 * 
 * @export
 * @interface CreateLeadAssignmentRequest
 */
export interface CreateLeadAssignmentRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateLeadAssignmentRequest
     */
    user_id: string;
    /**
     * 
     * @type {LeadAssignmentRole}
     * @memberof CreateLeadAssignmentRequest
     */
    role: LeadAssignmentRole;
}

/**
 * Check if a given object implements the CreateLeadAssignmentRequest interface.
 */
export function instanceOfCreateLeadAssignmentRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "user_id" in value;
    isInstance = isInstance && "role" in value;

    return isInstance;
}

export function CreateLeadAssignmentRequestFromJSON(json: any): CreateLeadAssignmentRequest {
    return CreateLeadAssignmentRequestFromJSONTyped(json, false);
}

export function CreateLeadAssignmentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLeadAssignmentRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'user_id': json['user_id'],
        'role': LeadAssignmentRoleFromJSON(json['role']),
    };
}

export function CreateLeadAssignmentRequestToJSON(value?: CreateLeadAssignmentRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user_id': value.user_id,
        'role': LeadAssignmentRoleToJSON(value.role),
    };
}

